import React from 'react';
import { ConsentDialogProps } from './types';
import { useConsentDialog } from './useConsentDialog';
import { ConsentDialogUI } from './ConsentDialogUI';

export const ConsentDialog: React.FC<ConsentDialogProps> = ({
  doctorId,
  prescriberEmail,
  prescriptionId,
  onClose,
}) => {
  const { state, actions } = useConsentDialog({
    doctorId,
    prescriberEmail,
    prescriptionId,
    onClose,
  });

  return (
    <ConsentDialogUI
      isVisible={state.isVisible}
      email={state.email}
      emailError={state.emailError}
      apiError={state.apiError}
      isSubmitting={state.isSubmitting}
      onEmailChange={actions.handleEmailChange}
      onAccept={actions.handleAccept}
      onRefuse={actions.handleRefuse}
      onClose={actions.handleClose}
    />
  );
};

export default ConsentDialog;
